import { useState, useEffect } from "react";

import find from "lodash/find";
import isEmpty from "lodash/isEmpty";

import { Box } from "@/storybook-components";

import { useAppSelector, useAppDispatch } from "@/redux/store/hooks";
import { fontFamilies } from "@/theme/font-families";
import DesktopNavLinks from "./desktop/nav-links";
import DesktopAuthLinks from "./desktop/auth-links";
import MobileNavLinks from "./mobile/nav-links";
import MobileAuthLinks from "./mobile/auth-links";
import ProfileLinks from "./mobile/profile-links";
import SearchBar from "./search-bar";
import HamburgerIcon from "./hamburger-icon";
import UserAvatar from "./user-avatar";
import Logo from "./logo";
import LiquidTemplateHeader from "../liquid-templates/header";

const ParticipantHeader = () => {
  const dispatch = useAppDispatch();
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false);
  const { theme } = useAppSelector((state) => state.theme);
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const login = useAppSelector((state) => state.user.registeredUser.profile);
  const fetchedContentFont = find(
    fontFamilies,
    (f) => f.key === theme.contentFont
  );
  const font =
    (fetchedContentFont && fetchedContentFont.name) || fontFamilies[0].name;
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const textColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarTextColor;

  const [navigator, setNavigator] = useState("");
  useEffect(() => {
    setNavigator(navigator);
  }, [dispatch]);

  const DesktopMenuNode = () => {
    return (
      <Box
        className="ehq-participant-header ehq-participant-header--desktop-menu"
        backgroundColor={backgroundColor}
        color={textColor}
        fontFamily={font}
      >
        <div className="ehq-participant-header__left-menu">
          <Logo />
        </div>
        <nav className="ehq-participant-header__right-menu">
          <DesktopNavLinks />
          <div className="ehq-participant-header__right-menu-auth-links">
            <SearchBar />
            {DesktopAuthLinksNode()}
          </div>
        </nav>
      </Box>
    );
  };
  const DesktopAuthLinksNode = () => {
    return <DesktopAuthLinks />;
  };
  const loadHeader = () => {
    return !isEmpty(login) ? (
      <Box
        className="ehq-participant-header ehq-participant-header__mobile-menu-items ehq-participant-mobile-over"
        color={textColor}
        fontFamily={font}
      >
        <MobileAuthLinks />
      </Box>
    ) : (
      <div className="ehq-participant-header__mobile-menu-items">
        <MobileNavLinks sectionId="0" loggedInUser="admin" />
        <MobileAuthLinks />
        <SearchBar />
      </div>
    );
  };
  const loadProfileMenu = () => {
    return !isEmpty(login) ? (
      <Box
        className="ehq-participant-header ehq-participant-header__mobile-menu-items ehq-participant-mobile-over"
        color={textColor}
        fontFamily={font}
      >
        <ProfileLinks />
      </Box>
    ) : (
      <Box
        className="ehq-participant-header__mobile-menu-items"
        color={textColor}
        fontFamily={font}
        backgroundColor={backgroundColor}
      >
        <MobileNavLinks sectionId="0" loggedInUser="admin" />
        <MobileAuthLinks />
        <SearchBar />
      </Box>
    );
  };
  const MobileMenuNode = () => {
    const isMenuOpen = isMobileMenuVisible || isProfileMenuVisible;
    return (
      <Box
        className={[
          "ehq-participant-header",
          "ehq-participant-header--mobile-menu",
          isMenuOpen ? "ehq-participant-header--menu-open" : null
        ]
          .filter(Boolean)
          .join(" ")}
        color={textColor}
        fontFamily={font}
        backgroundColor={backgroundColor}
      >
        <div className="ehq-participant-header__logo-container">
          <Logo />
          <span>
            {!isEmpty(login) && (
              <button
                onClick={handleProfileMenuVisibility}
                aria-expanded={isProfileMenuVisible}
                data-testid="participant-header-profile-menu-toggle"
              >
                <UserAvatar />
              </button>
            )}
            <HamburgerIcon
              onClick={handleMobileMenuVisibility}
              isMobileMenuVisible={isMobileMenuVisible}
            />
          </span>
        </div>
        {isMobileMenuVisible ? loadHeader() : false}
        {isProfileMenuVisible ? loadProfileMenu() : false}
      </Box>
    );
  };
  const handleMobileMenuVisibility = () => {
    setIsMobileMenuVisible(!isMobileMenuVisible);
    setIsProfileMenuVisible(false);
  };
  const handleProfileMenuVisibility = () => {
    setIsProfileMenuVisible(!isProfileMenuVisible);
    setIsMobileMenuVisible(false);
  };
  /**
   * Fix Navigation and search bar zoom-in on iPhones
   */
  const addMaximumScaleToMetaViewport = () => {
    setTimeout(function () {
      const el = document.querySelector("meta[name=viewport]");

      if (el !== null) {
        let content = el.getAttribute("content");
        const scale = /maximum-scale=[0-9.]+/g;

        content = scale.test(content)
          ? content.replace(scale, "maximum-scale=1.0")
          : [content, "maximum-scale=1.0"].join(", ");
        el.setAttribute("content", content);
      }
    }, 5000);
  };

  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
  const checkIsIOS = () => {
    // @ts-ignore
    return /iPad|iPhone|iPod/.test(navigator) && !window.MSStream;
  };

  if (checkIsIOS()) {
    addMaximumScaleToMetaViewport();
  }
  const HeaderNode = () => {
    return (
      <header>
        <LiquidTemplateHeader />
        <section>
          {DesktopMenuNode()}
          {MobileMenuNode()}
        </section>
      </header>
    );
  };
  return HeaderNode();
};

export default ParticipantHeader;
